<template>
  <v-app-bar class="dev-header" flat color="transparent">
    <v-img
      src="../../assets/dev/logo-dev.png"
      class="cursor-pointer"
      max-width="100"
      max-height="auto"
      @click="handleLoadTemplate"
    />

    <v-spacer />

    <DevEnvironments styleClass="mr-4" />

    <v-divider vertical inset />

    <DevAccount />
  </v-app-bar>
</template>

<script>
export default {
  components: {
    DevEnvironments: () => import('@/components/dev/dev-environments'),
    DevAccount: () => import('@/components/dev/dev-account')
  },

  computed: {
    schema() {
      return this.$store.getters['dev/getSchema'];
    },

    initialSchema() {
      return this.$store.getters['dev/getInitialSchema'];
    },

    typeOfPageEditing() {
      return this.$store.getters['dev/getTypeOfPageEditing'];
    }
  },

  methods: {
    handleLoadTemplate() {
      if (this.typeOfPageEditing !== '' && JSON.stringify(this.schema) !== JSON.stringify(this.initialSchema)) {
        this.$store.dispatch('dev/setConfirmPageChanges', {
          dialog: true,
          origin: 'header',
          fileName: '',
          redirect: ''
        });

        return;
      }

      this.$store.dispatch('dev/setTypeOfPageEditing', '');
      this.$store.dispatch('dev/setSchema');
      this.$store.dispatch('dev/setSelectedPage', '');
      this.$store.dispatch('dev/setCurrentTemplate', 'templateHome');
    }
  }
};
</script>
